
class DirectoriesTree {

    constructor(_dotNetRef) {
        this.dotNetRef = _dotNetRef;
    }

    onDirectoryDragStart(ev) {
        this.resourceId = ev.target.id.split("_")[1];
        ev.dataTransfer.setData("resourceId", this.resourceId);
    }

    onDirectoryDrop(ev, directoryId) {
        this.resourceId = ev.dataTransfer.getData("resourceId");
        this.directoryId = directoryId;        
        this.dotNetRef.invokeMethodAsync('MoveResource', parseInt(this.resourceId), parseInt(this.directoryId));
    }
}

window.directoriesTreeInstances = new Map();

window.directoriesTree = {

    init: function (_dotNetRef, _treeId) {

        if (window.directoriesTreeInstances.size > 0 && window.directoriesTreeInstances.has(_treeId))
        {
            console.log("Instance already exists: " + _treeId);
            return window.directoriesTreeInstances[_treeId];
        }

        let tree = new DirectoriesTree(_dotNetRef);

        window.directoriesTreeInstances.set(_treeId, tree);
        
        return tree;
    },

    getInstance: function (_treeId) {
        return window.directoriesTreeInstances.get(_treeId);
    },

    directoryAllowDrop(ev) {
        ev.preventDefault();
    },

    dispose(_treeId) {
        window.directoriesTreeInstances.delete(_treeId);
        console.log("Tree instance disposed: " + _treeId);
    }

}